var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('PageSummary',{attrs:{"headline":"My Teams"}},[_c('p',[_vm._v(" Teams you created, the good and the ugly. ")])]),_c('MyTeams')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }